import { render, staticRenderFns } from "./EmailReset.vue?vue&type=template&id=7baf093f&scoped=true&"
import script from "./EmailReset.vue?vue&type=script&lang=js&"
export * from "./EmailReset.vue?vue&type=script&lang=js&"
import style0 from "./EmailReset.vue?vue&type=style&index=0&id=7baf093f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7baf093f",
  null
  
)

/* custom blocks */
import block0 from "./EmailReset.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports